import React from 'react';

class CarouselLoadingPerson extends React.Component {
	render() {
		return (
			<div className="carousel-loading carousel-loading-person">
				<div className="carousel-loading-item carousel-loading-item-1">
					<div className="carousel-loading-item--inner"></div>
					<div className="text-wrap">
						<p className="title">
							<span className="year"></span>
						</p>
					</div>
				</div>
				<div className="carousel-loading-item carousel-loading-item-2">
					<div className="carousel-loading-item--inner"></div>
					<div className="text-wrap">
						<p className="title">
							<span className="year"></span>
						</p>
					</div>
				</div>
				<div className="carousel-loading-item carousel-loading-item-3">
					<div className="carousel-loading-item--inner"></div>
					<div className="text-wrap">
						<p className="title">
							<span className="year"></span>
						</p>
					</div>
				</div>
				<div className="carousel-loading-item carousel-loading-item-4">
					<div className="carousel-loading-item--inner"></div>
					<div className="text-wrap">
						<p className="title">
							<span className="year"></span>
						</p>
					</div>
				</div>
				<div className="carousel-loading-item carousel-loading-item-5">
					<div className="carousel-loading-item--inner"></div>
					<div className="text-wrap">
						<p className="title">
							<span className="year"></span>
						</p>
					</div>
				</div>
				<div className="carousel-loading-item carousel-loading-item-6">
					<div className="carousel-loading-item--inner"></div>
					<div className="text-wrap">
						<p className="title">
							<span className="year"></span>
						</p>
					</div>
				</div>
			</div>
		);
	}
}

export default CarouselLoadingPerson;
